module.exports = __webpack_public_path__ + "style/img/Group 2258(4).d922aa57.png";